// src/pages/BemVindo.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import LESVITA_LOGO from "../Assets/images/logo/iconeApp1024.webp";
import styles from "../styles/pages/BemVindo.module.css";
import APP_STORE_LOGO from "../Assets/icons/app_store_logo.svg";
import PLAY_STORE_LOGO from "../Assets/icons/play_store_logo.svg";
 
const AppleIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
  </svg>
);

const PlayIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3.18 23.76c.3.17.64.24.99.2l13.43-11.96-2.72-2.72L3.18 23.76zM20.74 10.56l-2.87-1.62-3.05 2.72 3.05 2.72 2.9-1.64c.83-.47.83-1.71-.03-2.18zM2.1.47C1.76.81 1.56 1.36 1.56 2.08v19.84c0 .72.2 1.27.54 1.61l.08.08 11.12-11.11v-.26L2.18.39 2.1.47zM14.49 7.9L3.18.26c-.35-.2-.67-.24-.99-.2l11.7 10.56 2.72-2.72z" />
  </svg>
);

const CheckCircleIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
    <circle cx="24" cy="24" r="24" fill="var(--color-accent, #FBBC04)" fillOpacity="0.15" />
    <circle cx="24" cy="24" r="17" fill="var(--color-accent, #FBBC04)" fillOpacity="0.25" />
    <circle cx="24" cy="24" r="11" fill="var(--color-accent, #FBBC04)" />
    <path d="M18 24.5L22 28.5L30 20.5" stroke="var(--color-primary, #0020A0)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const APP_STORE_URL = "https://apps.apple.com/us/app/lesvita-fit/id6753772111";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.lesvita.app&pcampaignid=web_share";

export default function BemVindo() {
  const navigate = useNavigate();
  const location = useLocation();

  const gymName = location.state?.gymName || null;
  const gymLogo = location.state?.gymLogo || null;

  const [platform, setPlatform] = useState("unknown");

  useEffect(() => {
    const ua = navigator.userAgent || "";
    if (/iPad|iPhone|iPod/.test(ua)) setPlatform("ios");
    else if (/Android/.test(ua)) setPlatform("android");
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>

        {/* ── Check ── */}
        <div className={styles.checkRow}>
          <CheckCircleIcon />
        </div>

        <h1 className={styles.title}>Bem-vindo(a)!</h1>
        <p className={styles.titleSub}>Seu cadastro está completo.</p>

        {/* ── Co-branding ── */}
        <div className={styles.cobrandRow}>
          <div className={styles.cobrandLogo}>
            {gymLogo ? (
              <img src={gymLogo} alt={gymName || "Academia"} className={styles.cobrandImg} />
            ) : (
              <div className={styles.cobrandFallback}>
                <span>{gymName ? gymName.slice(0, 2).toUpperCase() : "GY"}</span>
              </div>
            )}
          </div>

          <div className={styles.cobrandPlus}>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M6 1v10M1 6h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </div>

          <div className={styles.cobrandLogo}>
            <img src={LESVITA_LOGO} alt="LesVita" className={styles.cobrandImg} />
          </div>
        </div>

        {gymName && (
          <p className={styles.partnerLabel}>
            <strong>{gymName}</strong> em parceria com <strong>LesVita</strong>
          </p>
        )}

        {/* ── Copy de parceria ── */}
        <div className={styles.copyBlock}>
          <p className={styles.copyTitle}>Sua academia foi além.</p>
          <p className={styles.copyBody}>
            {gymName ? (
              <>
                A <strong>{gymName}</strong> escolheu a LesVita para elevar
                o cuidado com você — avaliação inteligente, treino
                personalizado e acompanhamento real direto no app.
              </>
            ) : (
              <>
                Sua academia escolheu a LesVita para elevar o cuidado com
                você — avaliação inteligente, treino personalizado e
                acompanhamento real direto no app.
              </>
            )}
          </p>
        </div>

        {/* ── Botões das lojas ──
            2.3.10: plataforma conhecida (mobile/nativo) mostra SÓ a loja
            daquela plataforma; desktop/desconhecido mostra as duas. */}
        <div className={styles.storeButtons}>
          {platform !== "android" && (
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles.storeBtn} ${platform === "ios" ? styles.storeBtnPrimary : styles.storeBtnSecondary}`}
            >
              <img src={APP_STORE_LOGO} height={24} alt="App Store" />
              <div className={styles.storeBtnText}>
                <span className={styles.storeBtnSub}>Baixar na</span>
                <span className={styles.storeBtnName}>App Store</span>
              </div>
            </a>
          )}

          {platform !== "ios" && (
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles.storeBtn} ${platform === "android" ? styles.storeBtnPrimary : styles.storeBtnSecondary}`}
            >
              <img src={PLAY_STORE_LOGO} height={24} alt="Google Play" />
              <div className={styles.storeBtnText}>
                <span className={styles.storeBtnSub}>Baixar no</span>
                <span className={styles.storeBtnName}>Google Play</span>
              </div>
            </a>
          )}
        </div>

        <div className={styles.divider}><span>ou</span></div>

        <button type="button" className={styles.btnNavegador} onClick={() => navigate("/plataforma/pessoal", { replace: true })}>
          Continuar no navegador
        </button>

        <p className={styles.hint}>Você pode baixar depois — sua conta já está criada.</p>

      </div>
    </div>
  );
}